/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileDto } from '../../models/profile-dto';

export interface ShopUpdateShopProfile$Params {
  'x-trace-id'?: string;
      body: ProfileDto
}

export function shopUpdateShopProfile(http: HttpClient, rootUrl: string, params: ShopUpdateShopProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileDto>> {
  const rb = new RequestBuilder(rootUrl, shopUpdateShopProfile.PATH, 'put');
  if (params) {
    rb.header('x-trace-id', params['x-trace-id'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProfileDto>;
    })
  );
}

shopUpdateShopProfile.PATH = '/api/shop/profile';
